import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { AppModal } from '../../../../global/Modal';

import { IAppModalProps } from '../../../../global/Modal/AppModal';
import AutoCompleteInput from '../../../../global/Input/AutoCompleteInput';
import { ISelectOptions } from '../../../../global/Input/SelectInput';
import { IMemberGroupFieldValue, IPermissionData } from './UserMemberManage';
import { useGetAllGroups } from '../../../../../hook/query/groupCRUD';

export interface IAddAccessToGroupModalProps extends IAppModalProps {
    currentGroup: IPermissionData[]
}

export interface IMemberGroupFieldValueSelectOptions extends ISelectOptions {
    parent_id?: any
}

export interface IGroupSelectOptions extends ISelectOptions {
    username: string,
}

export default function AddAccessToGroupModal({ currentGroup, onConfirm, ...other }: IAddAccessToGroupModalProps) {

    const { control, getValues, reset } = useForm<{ group: IMemberGroupFieldValue[] }>({
        defaultValues: {
            group: currentGroup.filter(item => item.is_remove === 0)
        }
    })

    const [groupOption, setGroupOption] = useState<IGroupSelectOptions[]>([])

    const { data: groupData, isLoading: groupLoading } = useGetAllGroups()


    const handleConfirm = (e: Event) => {
        let values = getValues();

        onConfirm?.(e, values.group)
    }

    useEffect(() => {
        if (groupData) {
            let sortMember = groupData.map(group => ({ id: group.id, group_master_uuid: group.uuid, uuid: group.uuid, value: group.uuid, name: group?.name, option: group?.name, is_remove: 0 }))
            setGroupOption(sortMember)
        }
    }, [groupData])

    const handleOnClose = () => {
        reset({ group: currentGroup.filter(item => item.is_remove === 0) })
        other?.onClose?.()
    }

    useEffect(() => {
        reset({
            group: currentGroup.filter(item => item.is_remove === 0)
        })
    }, [currentGroup])

    const isReadyToAction = !groupLoading

    return (
        <AppModal {...other} onConfirm={handleConfirm} onClose={handleOnClose}>
            <div>
                <AutoCompleteInput disabled={!isReadyToAction} label="รายชื่อกลุ่ม" multiple id="group" name="group" options={groupOption} control={control} />
            </div>
        </AppModal>
    );
}
